// src/utils/api.js (Superadmin)
import axios from "axios";

// 🟢 Detect environment
const isLocal = window.location.hostname === "localhost";

// 🟢 Create instance (DO NOT use global defaults)
const api = axios.create({
  baseURL: isLocal
    ? "http://localhost:5000/api"
    : "/api",
  // ❌ DO NOT use withCredentials (not needed for JWT)
});

// 🟢 Request Interceptor (dynamic token injection)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (user.tenantId) {
    config.headers["X-Tenant-Id"] = user.tenantId;
  }

  return config;
});

// 🟢 Debug log
console.log("🧩 Superadmin Axios initialized:", {
  baseURL: api.defaults.baseURL,
});


export default api;